import backgroundTeam from 'assets/images/bg/bg_team.png';
import leo from 'assets/images/team/Leo.png';
import thanh from 'assets/images/team/Thanh.png';
import akira from 'assets/images/team/Akira.png';
import ume from 'assets/images/team/Umezawa.png';
import wa from 'assets/images/team/Wa.png';
import {Container, Grid, makeStyles, Typography} from '@material-ui/core';
import React from 'react';

const data = [
  {
    name: 'Leo Bai',
    job: 'Founder',
    description:
      'He is one of the most excellent advisor in crypto market in Japan. Majored in Structured Finance and the experience based 5 years of experience in structured finance and private equity. Has supporting different Crypto/Blockchain Projects, Asian Brand Ambassador for 3 years',
    img: leo,
  },
  {
    name: 'Akira',
    job: 'CEO',
    description:
      'He was able to handle Windows95 when he was 10. He also built his own WinMX private server when he was 12years old He was the admin of a server with thousands of people. \n Now, he run an electmedical record card development company with 400 engineers from 6 companies in Vietnam.',
    img: wa,
  },

  {
    name: 'Munehiro Umezawa',
    job: 'Lead Investor. Partner. Co-Founder',
    description:
      'CEO of the Holonus blockchain project. \n We aim to build a new decentralized platform that will be the basis of the Internet society in the future. \nHe has been involved in financial business for over 10 years, and in the process he encountered blockchain and was shocked. \nBased on the belief that the basic concept of blockchain will become universal in the future society, we are also building a platform for decentralized finance.',
    img: ume,
  },
  {
    name: 'Do Tien Thanh',
    job: 'CTO',
    description:
      'After concurrently serving as CTO for a major Japanese company, he is currently serving as a director of IT vendor in Vietnam with 50 engineers. He is currently serving as CTO for the himegami protocol.',
    img: thanh,
  },
  {
    name: 'Prince of the Earth',
    job: 'Virtal Marketer',
    description:
      "He's an influencer, focusing on TikTok. During his career, his followers exceeded 3k. He's not a human in TikTok, He is a character. The biggest characteristic is to inform information easily. He's grown so big in the short term, we're looking forward to his growth even more !",
    img: akira,
  },
];

const ShinobiTeam = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.background}>
        <Container maxWidth={'lg'} className={classes.root}>
          <Typography
            variant="h3"
            style={{
              marginBottom: 16,
              textAlign: 'center',
              fontWeight: 700,
              color: '#463A6D',
            }}>
            Team
          </Typography>
          <Typography
            variant="h5"
            style={{marginBottom: 32, textAlign: 'center', fontWeight: 700}}>
            Shinobi Wallet team is made up of members from Japan, Korea, China
            and Vietnam.
          </Typography>
          <Grid container spacing={3}>
            {data.map((item, index) => (
              <Grid container item md={6} sm={12} xs={12} key={index}>
                <Grid item md={6} sm={5} xs={5} className={classes.avatar}>
                  <img src={item.img} className={classes.large} />
                </Grid>
                <Grid item md={6} sm={7} xs={7} className={classes.textDes}>
                  <Typography variant="h5" className={classes.namePeople}>
                    {item.name}
                  </Typography>
                  <Typography variant="subtitle1">{item.job}</Typography>
                  <Typography className={classes.description}>
                    {item.description}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Container>
      </div>
    </React.Fragment>
  );
};
const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(10),
  },
  large: {
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: 'auto',
    },
  },
  background: {
    backgroundImage: `url(${backgroundTeam})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    [theme.breakpoints.down('xs')]: {
      backgroundColor: '#efeef6',
      backgroundImage: 'none',
      paddingTop: 24,
    },
  },
  textDes: {
    backgroundColor: '#fff',
    paddingRight: 20,
    maxHeight: 386,
    overflowY: 'auto',
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 16,
    },
    [theme.breakpoints.down('xs')]: {
      maxHeight: 205,
      paddingLeft: 16,
    },
  },
  namePeople: {
    fontWeight: 'bold',
    marginBottom: 6,
    marginTop: 20,
    [theme.breakpoints.down('xs')]: {
      marginTop: 16,
      marginBottom: 0,
    },
  },
  avatar: {
    backgroundColor: '#fff',
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      maxHeight: 205,
    },
  },
  description: {
    marginTop: 10,
    marginBottom: 20,
    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
      marginBottom: 20,
      fontSize: 14,
    },
  },
}));

export default ShinobiTeam;
